import { qrCodesUrls } from 'config/routes/qrCodes'
import { reportUrls } from 'config/routes/reports'
import { accountUrls } from './accounts'
import { aiSubsystemUrls } from './aiSubsystem'
import { alertRuleUrls } from './alertRules'
import { alertUrls } from './alerts'
import { authUrls } from './auth'
import { deviceGroupsUrls } from './deviceGroups'
import { devicesUrls } from './devices'
import { emailsUrls } from './emails'
import { gatewayUrls } from './gateways'
import { indicatorUrls } from './indicators'
import { locationUrls } from './locations'
import { loginHistoryUrls } from './loginHistory'
import { loraDevicesUrls } from './loraDevices'
import { measurementsUrls } from './measurements'
import { modelUrls } from './models'
import { organizationUrls } from './organization'
import { packetUrls } from './packets'
import { parserUrls } from './parsers'
import { snmpDevicesUrls } from './snmp'
import { snmpOidsUrls } from './snmpOids'
import { usersUrls } from './users'
import { tagsUrls } from './tags'

export const r = {
  index: '/',
  panel: '/panel',
  ...authUrls,
  ...gatewayUrls,
  ...loraDevicesUrls,
  ...locationUrls,
  ...organizationUrls,
  ...deviceGroupsUrls,
  ...usersUrls,
  ...tagsUrls,
  ...accountUrls,
  ...loginHistoryUrls,
  ...alertRuleUrls,
  ...measurementsUrls,
  ...devicesUrls,
  ...emailsUrls,
  ...alertUrls,
  ...aiSubsystemUrls,
  ...snmpDevicesUrls,
  ...parserUrls,
  ...indicatorUrls,
  ...modelUrls,
  ...packetUrls,
  ...snmpOidsUrls,
  ...qrCodesUrls,
  ...reportUrls,
}
